import { getDataLayer } from '@kissui/helpers/src/dataLayer'

export async function setPDPDataProvider() {
    window.getPDPData = window.getPDPData || getPDPData
}

export async function getPDPData() {
    return await window.pdpData
}

export async function market() {
    return napi.market().read() // eslint-disable-line
}

export function getCurrency() {
    return getDataLayer().currency
}

export async function getPriceFormatter() {
    return napi.priceFormat() // eslint-disable-line
}
